import React from "react";
import { LoginPageForm } from "./";
import CssBaseline from "@material-ui/core/CssBaseline";

const LoginPageNoStyles = () => {
  return (
    <div>
      <CssBaseline />
      <LoginPageForm />
    </div>
  );
};

export default LoginPageNoStyles;
